import { render, staticRenderFns } from "./EmailTemplateSelect.vue?vue&type=template&id=71b53a88&"
import script from "./EmailTemplateSelect.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports